// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603241304/js/" + chunkId + "." + {"44":"0865564b","225":"99dbfbb5","481":"d3f0cf13","486":"487e1b4d","770":"8d96b47e"}[chunkId] + ".0.29552401072851486.chunk.js";
};